export default {
  /**
   * @param {Object} state
   * @returns {Array}
   */
  journalDates(state) {
    return state.journal.dates
  },
}
